import React from "react";
import TableWidget from "../../../components/tables/TableWidget";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { getDevicesNomenclature } from "../../../redux/api/admin.api";

import { TableActions } from "../../../components/tables/tableContext/TableContext";
import {
  devicesNomenclatureTableHeader,
  getDevicesNomenclatureTableData,
} from "./tableConfigs/devicesNomenclatureTableConfig";
import DevicesNomenclatureActionButtons from "./tableConfigs/DevicesNomenclatureActionButtons";
import DevicesNomenclatureCustomHeader from "./components/DevicesNomenclatureCustomHeader";

function DevicesNomenclature() {
  const dispatch = useAppDispatch();

  const {
    admin: {
      devicesNomenclature: {
        data: { data: devicesData, total },
        isLoading,
      },
    },
  } = useAppSelector((state) => ({
    admin: state.admin,
  }));

  const handleTableActions = (action: TableActions) => {
    if (action.tablePagination.page && action.tablePagination.rowsPerPage) {
      dispatch(
        getDevicesNomenclature({
          ...action.tableSearch,
          page: action.tablePagination.page,
          per_page: action.tablePagination.rowsPerPage,
        }),
      );
    }
  };

  return (
    <TableWidget
      tableHeaderData={devicesNomenclatureTableHeader}
      tableItemsData={getDevicesNomenclatureTableData(devicesData)}
      handleTableActions={handleTableActions}
      CustomHeaderComponent={DevicesNomenclatureCustomHeader}
      ActionButtonsComponent={DevicesNomenclatureActionButtons}
      tableLoading={isLoading}
      totalItems={total}
      borderedRow
    />
  );
}

export default DevicesNomenclature;
